<script lang="ts" setup>
const { text: textArray } = defineProps<{ text: string[], textClass: string }>()
const typingDelay = ref(200)
const erasingDelay = ref(100)
const newTextDelay = ref(2000)
const textArrayIndex = ref(0)
const charIndex = ref(0)
const typedTextSpan = ref<HTMLElement>()
const cursorSpan = ref<HTMLElement>()

function type() {
  if (!cursorSpan.value || !typedTextSpan.value || !textArray?.length)
    return
  if (charIndex.value < textArray[textArrayIndex.value].length) {
    if (!cursorSpan.value.classList.contains('typing'))
      cursorSpan.value.classList.add('typing')
    typedTextSpan.value.textContent += textArray[textArrayIndex.value].charAt(charIndex.value)
    charIndex.value++
    setTimeout(() => type(), typingDelay.value)
  }
  else {
    cursorSpan.value.classList.remove('typing')
    setTimeout(() => erase(), newTextDelay.value)
  }
}

function erase() {
  if (!cursorSpan.value || !typedTextSpan.value)
    return
  if (charIndex.value > 0) {
    if (!cursorSpan.value.classList.contains('typing'))
      cursorSpan.value.classList.add('typing')
    typedTextSpan.value.textContent = textArray[textArrayIndex.value].substring(0, charIndex.value - 1)
    charIndex.value--
    setTimeout(() => erase(), erasingDelay.value)
  }
  else {
    cursorSpan.value.classList.remove('typing')
    textArrayIndex.value++
    if (textArrayIndex.value >= textArray.length)
      textArrayIndex.value = 0
    setTimeout(() => type(), typingDelay.value + 1100)
  }
}

onMounted(() => setTimeout(() => type(), 1000))
</script>

<template>
  <span class="p">
    <span ref="typedTextSpan" class="typed-text" :class="textClass" />
    <span ref="cursorSpan" class="cursor">&nbsp;</span>
  </span>
</template>

<style scoped>
.p {
  overflow: hidden;
}

.p span.cursor {
  display: inline-block;
  background-color: #ccc;
  margin-left: 0.1rem;
  width: 3px;
  animation: blink 1s infinite;
}
.p span.cursor.typing {
  animation: none;
}
@keyframes blink {
  0%  { background-color: #ccc; }
  49% { background-color: #ccc; }
  50% { background-color: transparent; }
  99% { background-color: transparent; }
  100% { background-color: #ccc; }
}
</style>
